import { render, staticRenderFns } from "./createAnswer.vue?vue&type=template&id=767b718a&"
import script from "./createAnswer.vue?vue&type=script&lang=js&"
export * from "./createAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports